import { render } from "./Eventstatistics.vue?vue&type=template&id=21571cdc"
import script from "./Eventstatistics.vue?vue&type=script&lang=js"
export * from "./Eventstatistics.vue?vue&type=script&lang=js"

import "./Eventstatistics.vue?vue&type=style&index=0&id=21571cdc&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__